import { z } from 'zod';

export const bank_records_csv_import_schema = z.object({
  Date: z.string().refine(
    (date) => {
      return date.match(/^\d{4}-\d{2}-\d{2}$/);
    },
    {
      message: 'Please provide a date in the format YYYY-MM-DD',
    }
  ),
  Description: z.coerce.string({ error: 'Description is required' }),
  Amount: z.number({
    error: 'Amount must be a number',
  }),
});
